// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2c0dH","balanceDisclaimer":"posDashboard_balanceDisclaimer__zHxyv"};